import styled from "styled-components";

export const Container = styled.footer`
    width: 100%;    
    padding: 40px 0;
    background-color: #05164a;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        padding: 30px 20px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
`
export const Logo = styled.img`
    width: 100%;
    max-width: 322px;
    max-height: 140px;
    display: block;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        max-width: 460px;
        max-height: 200px;
    }
`
